import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { RadioButtonStyle } from './Component.style';

import { ReactComponent as Exclamation } from 'assert/images/Common/exclamation.svg';

export default function RadioButton({
  onChange,
  value,
  label,
  options,
  required,
  disabled,
  errMsg,
  fontSize,
  ...others
}) {
  return (
    <RadioButtonStyle className="radio-container">
      {label && (
        <div className="lebelView">
          <label>
            {label} {required && <span className="requiredSymbol">*</span>}
          </label>
        </div>
      )}
      <RadioGroup
        aria-labelledby="radio-label"
        value={value}
        onChange={onChange}
        {...others}
      >
        {options.map((item, index) => {
          return (
            <>
              <FormControlLabel
                className="radio-label"
                key={index}
                disabled={item.disabled}
                value={item.value}
                control={<Radio />}
                label={item.label}
                sx={{
                  '& .MuiSvgIcon-root': {
                    fontSize: fontSize || 20,
                  },
                }}
              />
              {item?.helperText && <div className='radio-helperText'>{item?.helperText}</div>}
            </>
          );
        })}
      </RadioGroup>
      {errMsg && !value && (
        <span className="errMsg">
          <Exclamation />
          {errMsg}
        </span>
      )}
    </RadioButtonStyle>
  );
}
